module.exports = __webpack_public_path__ + "img/x-circle-fill-violet.0ec55283.svg";